module.exports = __webpack_public_path__ + "img/court-zero-1.4fe52417.jpg";